import React from "react";

declare const I18n;

type Props = {
  step: number;
  onPrev: () => void;
  onNext: () => void;
  onSkip?: () => void;
  disableNext?: boolean;
  showBackButton: boolean;
  showContinueButton: boolean;
  showSignupButton: boolean;
  showSkipButton?: boolean;
};

const SignupNavigation: React.FC<Props> = ({ step, onPrev, onSkip, onNext, disableNext, showBackButton, showContinueButton, showSignupButton, showSkipButton }) => {
  return (
      <div
        style={{
          marginTop: "1rem",
          paddingTop: "1rem",
          display: "flex",
          justifyContent: "center",
          gap: "3.75rem",
        }}
      >
        <div 
          style={{ 
            display: "flex", 
            gap: "0.6rem"
          }}
        >
        {showBackButton && (
          <button
            onClick={onPrev}
            className="btn btn-primary-outline"
          >
            {I18n.t("views.onboarding.navigation.back")}
          </button>
        )}

        {/* {showSkipButton && (
          <button
            onClick={onSkip}
            className="btn btn-primary-outline"
          >
            {I18n.t("views.onboarding.navigation.skip_for_now")}
          </button>
        )} */}
        </div>

        {showSignupButton && (
          <button
            onClick={onNext}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !disableNext) {
                e.preventDefault();
                onNext();
              }
            }}
            className="btn btn-primary"
            disabled={disableNext}
            style={{
              cursor: disableNext ? "not-allowed" : "pointer",
            }}
          >
            {I18n.t("views.onboarding.navigation.signup")}
          </button>
        )}

        {showContinueButton && !showSignupButton && (
          <button
            onClick={onNext}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !disableNext) {
                e.preventDefault();
                onNext();
              }
            }}
            className="btn btn-primary"
            disabled={disableNext}
            style={{
              cursor: disableNext ? "not-allowed" : "pointer",
            }}
          >
            {I18n.t("views.onboarding.navigation.continue")}
          </button>)}
      </div>
  );
};

export default SignupNavigation;
